var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('api-list',{attrs:{"type":"itemsTrackingHistoryEvents","model":_vm.models.itemsTrackingHistoryEvents,"quick-filters":_vm.quickFiltersSetup.itemsTrackingHistoryEvents,"preFilters":[['item_id', 'eq', _vm.item.id]],"no-querystring":"","in-modal":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }